import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import CommonStructured from "../../common-components/CommonStructured";
import FeatureFeedbackForm from "./FeatureFeedbackForm";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import FeedbackListings from "./FeedbackListings";
import { fetchDashboardFeedbacksData } from "../../../redux/dashboard-features/featuresSlice";
import CmnFilters from "../../lead-management/common/CmnFilters";
import { isMoreThan7DaysOld } from "../../common-data/Converts";

const FeedbackLogs = ({ userInfoData, rowData, prevOnCloseModal }) => {
  const dispatch = useDispatch();
  const { featureDocLoading } = useSelector((state) => state.features);

  const isAdmin = userInfoData?.account_type === "admin";

  const isEnableAddingFeedback = rowData?.last_updated
    ? isMoreThan7DaysOld(rowData.last_updated)
    : true;

  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    // selectedFeature: rowData?.feature_id
    //   ? {
    //       label: rowData?.feature_name || "",
    //       value: rowData?.feature_id || "",
    //     }
    //   : "",
    accountType: !isAdmin
      ? {
          label: userInfoData?.account_type?.replace(/_/g, " ") || "",
          value: userInfoData?.account_type || "",
        }
      : "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    user_id: !isAdmin ? userInfoData?.uid || userInfoData?.user_id : "",
    page: isPage + 1,
    limit: pageLimit || 10,
    feature_id: rowData?.feature_id || "",
    account_type: allFilters.accountType?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getAllFeedbacks(filters) {
    dispatch(
      fetchDashboardFeedbacksData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getAllFeedbacks(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      account_type: allFilters.accountType?.value || "",
    }));
  }, [isPage, pageLimit, allFilters.accountType]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Modal"
        ariaHideApp={false}
      >
        {modValues.cardName === "add" || modValues.cardName === "edit" ? (
          <FeatureFeedbackForm
            userInfoData={userInfoData}
            rowData={modValues.rowData}
            isEdit={modValues.cardName === "edit"}
            closeModal={onCloseModal}
            callFunction={() => getAllFeedbacks(filters)}
            featureInfo={rowData || ""}
          />
        ) : (
          <div className={`createNewCTOModalContainer`}>
            <ModalHeadAndClose
              title={`${modValues.cardName?.replace(/_/g, " ")}`}
              onClose={onCloseModal}
            />
          </div>
        )}
      </Modal>

      <Row>
        <Col>
          <CommonStructured
            pageHeading={`${rowData?.feature_name || ""} Feedback And Rating`}
            createBtnTxt={isEnableAddingFeedback ? "+ Add New Feedback" : null}
            onClickCreateBtn={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "add",
              }))
            }
            isReload={() => getAllFeedbacks(filters)}
            onCloseModal={prevOnCloseModal}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <CmnFilters
            from={"feedbacks"}
            userInfoData={userInfoData}
            onClickReset={onResetFilters}
            filters={allFilters}
            setFilters={setAllFilters}
            onClickSearch={onClickSearch}
            searchFilterApplied={searchFilterApplied}
            isLoading={featureDocLoading}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <FeedbackListings
            userInfoData={userInfoData}
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            setModValues={setModValues}
            callFunction={() => getAllFeedbacks(filters)}
          />
        </Col>
      </Row>
    </>
  );
};

export default FeedbackLogs;
